import { Theme } from "@material-ui/core/styles";
import { createStyles, makeStyles } from "@material-ui/core";
const BgLight = "/assets/svg/bg-light.svg";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      minHeight: "100vh",
      backgroundColor: "rgba(249,250,251,0.5)",
      overflow: "hidden",
      letterSpacing: "-0.025em",
      width: "100vW",
    },
    leftWidthNormal: {
      width: "50%",
    },
    leftWidthDouble: {
      width: "35%",
    },
    left: {
      position: "fixed",
      top: 0,
      left: 0,
      height: "100%",
      zIndex: 40,
      transition: "transform 0.3s ease-in-out",

      transform: "translateX(0)",
      "@media (max-width: 768px)": {
        transform: "translateX(-100%)",
      },
    },
    rightWidthNormal: {
      width: "50%",
      marginLeft: "50%",
    },
    rightWidthDouble: {
      width: "65%",
      marginLeft: "35%",
    },
    right: {
      display: "flex",
      transition: "margin-left 0.3s ease-in-out",
      "@media (max-width: 768px)": {
        width: "100%",
        transform: "translateX(0)",
        marginLeft: 0,
      },
    },
    contentRight: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      overflowX: "hidden",
      overflowY: "hidden",
    },
    contentLeft: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      overflowX: "hidden",
      overflowY: "hidden",
      padding: theme.spacing(4),
    },
    background: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -2, // L'image reste en arrière-plan
      backgroundPosition: "top",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      objectFit: "cover",
      backgroundImage: `linear-gradient(to bottom,rgba(30, 136, 229, 0.87),rgba(0, 187, 212, 0.87)), url(${BgLight})`,
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.3)",
      width: "100%",
      height: "100%",
      // backdropFilter: "blur(3px)", // Disabled
      zIndex: -1,
      transition: "transform 0.3s ease-in-out",
      cursor: "pointer",
      "@media (max-width: 768px)": {
        transform: "translateX(-100%)",
      },
    },
    header: {
      display: "flex",
      alignItems: "end",
      justifyContent: "center",
      flexDirection: "row",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },

    headTitle: {
      fontWeight: "bold",
      fontSize: "2.5rem",
      color: "#fff",
    },
    logo: {
      width: 35,
    },

    headerRow: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(4),
    },
    title: {
      fontWeight: 700,
      fontSize: "2.25rem",
      lineHeight: "2.5rem",
      marginBottom: "1.5rem",
      color: "#fff",
    },
    description: {
      fontSize: "1.25rem",
      color: "#fff",
      opacity: ".9",
    },
    card: {
      borderRadius: theme.shape.borderRadius * 3,
      margin: theme.spacing(2),
    },
    cardContent: {
      margin: theme.spacing(2),
    },
    loadingNormal: {
      position: "absolute",
      top: "50%",
      left: "75%",
      "@media (max-width: 768px)": {
        top: "50%",
        left: "50%",
      },
    },
    loadingDouble: {
      position: "absolute",
      top: "50%",
      left: "65%",
      "@media (max-width: 768px)": {
        top: "50%",
        left: "50%",
      },
    },
  }),
);
